export default __webpack_public_path__ + "static/media/design-center-img-2.0fc2ce95.png";